import { Button, Grid, TextField } from "@mui/material";
import muistyled from "@emotion/styled";
import { JelloAnimation } from "../../animations/animations";

export const ContactMeMainContainer = muistyled(Grid, {
  name: "ContactMeMainContainer",
})({
  direction: "column",
  height: "700px",
  backgroundColor: "#809A6F",
  display: "flex",
  flexWrap: "wrap",
  overflow: "auto",
});

export const FormContainer = muistyled(Grid, {
  name: "FormContainer",
})({
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
});

export const FormInputsContainer = muistyled(Grid, {
  name: "FormInputsContainer",
})({
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
});
export const StyledTextField = muistyled(TextField, {
  name: "StyledTextField",
})({
  "& label.Mui-focused": {
    color: "white",
    fontFamily: "Oswald",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "white",
    },
    "&:hover fieldset": {
      borderColor: "#1E2022",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
    },
  },
  fontWeight: "bold",
  marginTop: "5px",
  marginBottom: "5px",
  width: "100%",
  height: "70px",
});

export const InputWrapper = muistyled(Grid, {
  name: "InputWrapper",
})({
  justifyContent: "center",
  alignItems: "center",
});

export const ContactMeHeader = muistyled("h1", {
  name: "ContactMeHeader",
})({
  color: "#fff",
  fontSize: "1.5",
  fontWeight: "bold",
  textAlign: "center",
  fontFamily: "Oswald",
  "@media (min-width: 630px)": {
    fontSize: "50px",
  },
});
export const SubmitButton = muistyled(Button, {
  name: "SubmitButton",
})({
  height: "50px",
  width: "150px",
  borderRadius: "6px",
  backgroundColor: "#fff",
  margin: "20px",
  color: "#000",
  fontWeight: "bold",
  ":hover": {
    animation: `${JelloAnimation} 1s both`,
  },
});

export const StyledImage = muistyled("img", {
  name: "StyledImage",
})({
  height: "500px",
  width: "500px",
  borderRadius: "50%",
  "@media (max-width: 900px)": {
    height: "225px",
    width: "225px",
    borderRadius: "30%",
  },

});
